import { render, staticRenderFns } from "./ChangePassword.html?vue&type=template&id=2e7a378c&scoped=true&external"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.scss?vue&type=style&index=0&id=2e7a378c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a378c",
  null
  
)

export default component.exports